<template>
  <div v-loading="pageLoading">
    <!-- 補交 -->
    <template v-if="isFollowing">
      <!-- 車輛信息 -->
      <CheckFormBox v-if="vehicle" :title="$t('hzmbG.title.vehicle')">
        <el-row :gutter="48" type="flex">
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbH.label.registrationNo')">
              <span>{{ vehicle.registrationNo }}</span>
            </CheckRowText>
          </el-col>
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbG.label.mainlandInsuranceNo')">
              <span>{{ vehicle.mainlandInsuranceNo }}</span>
            </CheckRowText>
          </el-col>
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbG.label.mainlandInsuranceStartDate')">
              <span>
                {{
                  vehicle.mainlandInsuranceStartDate | formatDT("dd/MM/yyyy")
                }}
              </span>
            </CheckRowText>
          </el-col>
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbG.label.mainlandInsuranceEndDate')">
              <span>
                {{ vehicle.mainlandInsuranceEndDate | formatDT("dd/MM/yyyy") }}
              </span>
            </CheckRowText>
          </el-col>
        </el-row>
      </CheckFormBox>
      <!-- 車輛信息 end -->
    </template>
    <!-- 首次提交 -->
    <template v-else>
      <!-- 車輛信息 -->
      <CheckFormBox v-if="vehicle" :title="$t('hzmbG.title.vehicle')">
        <el-row :gutter="48" type="flex">
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbH.label.registrationNo')">
              <span>{{ vehicle.registrationNo }}</span>
            </CheckRowText>
          </el-col>
          <!-- <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbG.label.mainlandInsuranceNo')">
              <span>{{ vehicle.mainlandInsuranceNo }}</span>
            </CheckRowText>
          </el-col> -->
          <!-- <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbG.label.mainlandInsuranceStartDate')">
              <span>
                {{
                  vehicle.mainlandInsuranceStartDate | formatDT("dd/MM/yyyy")
                }}
              </span>
            </CheckRowText>
          </el-col> -->
          <!-- <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbG.label.mainlandInsuranceEndDate')">
              <span>
                {{ vehicle.mainlandInsuranceEndDate | formatDT("dd/MM/yyyy") }}
              </span>
            </CheckRowText>
          </el-col> -->
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbH.label.mainlandRegistrationNo')">
              <span>{{ vehicle.mainlandRegistrationNo }}</span>
            </CheckRowText>
          </el-col>
        </el-row>
      </CheckFormBox>
      <!-- 車主資料 -->
      <CheckFormBox v-if="owner" :title="$t('hzmbH.title.ownerInfo')">
        <el-row :gutter="48" type="flex">
          <template v-if="isPerson">
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbH.label.identityType')">
                <span>
                  {{
                    findByBase(owner.identityType, identityTypeList)[localeAttr]
                  }}
                </span>
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbH.label.identityNo')">
                <span>{{ owner.identityNo }}</span>
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbH.label.nameCn')">
                <span>{{ owner.nameCn }}</span>
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbH.label.nameEn')">
                <span>{{ owner.nameEn }}</span>
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbG.label.birthday')">
                <span>{{ owner.birthdate }}</span>
              </CheckRowText>
            </el-col>
          </template>
          <template v-if="isCompany">
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbH.label.companyIdentityType')">
                <span>
                  {{
                    findByBase(
                      owner.companyIdentityType,
                      companyIdentityTypeList,
                      "value"
                    )["label"]
                  }}
                </span>
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbH.label.companyBrNo')">
                <span>{{ owner.companyBrNo }}</span>
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbH.label.companyBrNameCn')">
                <span>{{ owner.companyBrNameCn }}</span>
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbH.label.companyBrNameEn')">
                <span>{{ owner.companyBrNameEn }}</span>
              </CheckRowText>
            </el-col>
          </template>
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbH.label.macauMobile')">
              <span>+853 {{ owner.macauMobile }}</span>
            </CheckRowText>
          </el-col>
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbH.label.hongKongMobile')">
              <span>+852 {{ owner.hongKongMobile }}</span>
            </CheckRowText>
          </el-col>
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbH.label.otherMobile')">
              <span>{{ owner.otherMobile }}</span>
            </CheckRowText>
          </el-col>
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbH.label.mainlandPhone')">
              <span>+86 {{ owner.mainlandPhone }}</span>
            </CheckRowText>
          </el-col>
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbH.label.mainlandEmail')">
              <span>{{ owner.mainlandEmail }}</span>
            </CheckRowText>
          </el-col>
          <el-col :xs="24" :sm="24">
            <CheckRowText :label="$t('hzmbH.label.macauAddress')">
              <span>{{ owner.macauAddress }}</span>
            </CheckRowText>
          </el-col>
          <!-- <el-col :xs="24" :sm="24">
            <CheckRowText :label="$t('hzmbH.label.hongKongAddress')">
              <span>{{ owner.hongKongAddress }}</span>
            </CheckRowText>
          </el-col> -->
        </el-row>
      </CheckFormBox>
      <!-- 駕駛員信息 -->
      <CheckFormBox
        v-if="drivers.length > 0"
        :title="$t('hzmbG.title.drivers')"
      >
        <div v-for="(item, index) in drivers" :key="index">
          <div class="check_drivers_title">
            {{
              $t("hzmbG.title.driversIndex", [
                $t(`message.capitalLetter[${index + 1}]`),
              ])
            }}
          </div>
          <el-row :gutter="48" type="flex">
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbH.label.nameCn')">
                {{ item.nameCn }}
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbH.label.nameEn')">
                {{ item.nameEn }}
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbH.label.identityNo')">
                {{ item.identityNo }}
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbG.label.birthday')">
                {{ item.birthdate | formatDT("dd/MM/yyyy") }}
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbG.label.sex')">
                {{ findByBase(item.sex, sexList)[localeAttr] }}
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbG.label.nationality')">
                {{ findByBase(item.nationality, nationalityList)[localeAttr] }}
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbH.label.macaoDrivingLicenseType')">
                {{
                  findByBase(
                    item.macauDrivingLicenseType,
                    drivingLicenseTypeList
                  )[localeAttr]
                }}
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbH.label.macaoDrivingLicenseNo')">
                {{ item.macauDrivingLicenseNo }}
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbH.label.macauMobile')">
                <span>+853 {{ item.macauMobile }}</span>
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="24">
              <CheckRowText :label="$t('hzmbH.label.macauAddress')">
                <span>{{ item.macauAddress }}</span>
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbH.label.mainlandPhone')">
                <span>+86 {{ item.mainlandMobile }}</span>
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbH.label.mainlandEmail')">
                <span>{{ item.mainlandEmail }}</span>
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbH.label.mainlandDrivingLicenseNo')">
                <span>{{ item.mainlandDrivingLicenseNo }}</span>
              </CheckRowText>
            </el-col>
            <el-col :xs="24" :sm="12">
              <CheckRowText :label="$t('hzmbH.label.mainlandDrivingPermitNo')">
                <span>{{ item.mainlandDrivingPermitNo }}</span>
              </CheckRowText>
            </el-col>
          </el-row>
        </div>
      </CheckFormBox>
      <!-- 駕駛員信息 end -->
    </template>
    <!-- 已上傳文件 -->
    <template v-if="application.documents && application.documents.length > 0">
      <div class="check_title">
        {{ $t("message.DataRegistration.check.already_upload_file") }}
      </div>
      <div class="check_file_list">
        <div
          v-for="(item, index) in application.documents"
          :key="item.id"
          class="check_file_list_content"
        >
          <div v-if="item.file">
            <span>
              {{ index + 1 }}.{{
                item.documentType &&
                item.documentType[`name${$t("message.lan")}`]
              }}：
            </span>
            <span class="check_file_name">
              &nbsp;{{ item.file && item.file.filename }}
            </span>
          </div>
        </div>
      </div>
    </template>
    <!-- 按鈕區 -->
    <div class="next_btn">
      <GradientBtn @click="back">{{ $t("message.back") }}</GradientBtn>
      <GradientBtn @click="onSubmit" :loading="submitLoading">
        {{ $t("message.DataRegistration.check.submit") }}
      </GradientBtn>
    </div>
    <!-- 按鈕區 end -->
  </div>
</template>

<script>
import { getDetail, submit } from "@/api/hzmb-gh/HzmbHApplicationApi";
import VssViewAPI from "@/api/hzmb-gh/VssViewAPI";
import GradientBtn from "@/components/GradientBtn.vue";
import CheckRowText from "@/components/CheckRowText.vue";
import CheckFormBox from "../../Check/components/CheckFormBox.vue";

export default {
  components: { CheckFormBox, CheckRowText, GradientBtn },
  data() {
    return {
      pageLoading: false,
      submitLoading: false,
      application: {},
      identityTypeList: [],
      companyIdentityTypeList: [],
      sexList: [],
      nationalityList: [],
      drivingLicenseTypeList: [],
    };
  },
  computed: {
    isPerson() {
      return ["HZMB_H_FIRST_PERSON"].includes(this.serviceType);
    },
    isCompany() {
      return ["HZMB_H_FIRST_COMP"].includes(this.serviceType);
    },
    isFollowing() {
      return this.application.status === "FOLLOWING";
    },
    vehicle() {
      return this.application.vehicle;
    },
    owner() {
      return this.application.owner;
    },
    drivers() {
      return this.application?.drivers ?? [];
    },
    documents() {
      return this.application.documents;
    },
    localeAttr() {
      return (
        ["codeCname", "codePname"][
          ["ZH_TW", "PT"].indexOf(this.$i18n.locale)
        ] || "codeMasterCname"
      );
    },
  },
  created() {
    this.getSomething();
  },
  methods: {
    //
    async getSomething() {
      this.pageLoading = true;

      try {
        let { f = "" } = this.$route.query;
        this._verifyForm =
          JSON.parse(localStorage.getItem(`verifyFormH${f}`)) || {};
        let { serviceType, registrationNo, identificationNo } =
          this._verifyForm;
        this.serviceType = serviceType;
        let application = await getDetail({
          serviceType,
          registrationNo,
          identificationNo,
        });
        this.application = {
          ...application,
          drivers: application.drivers.filter((item) => item),
        };

        if (this.isPerson) {
          this.identityTypeList = await VssViewAPI.getIdentityTypes();
        } else if (this.isCompany) {
          this.companyIdentityTypeList =
            await VssViewAPI.getCompanyIdentityTypes();
        }
        this.sexList = await VssViewAPI.getsexs();
        this.nationalityList = await VssViewAPI.getNationalitys();
        this.drivingLicenseTypeList = await VssViewAPI.getDrivingLicenseTypes();
      } catch (error) {
        this.$error(error);
      } finally {
        this.pageLoading = false;
      }
    },
    //
    findByBase(value, data, name = "codeKey") {
      const obj = data.find((e) => e[name] === value);
      if (obj) return obj;
      else return { [this.localeAttr]: "-" };
    },
    //
    async onSubmit() {
      try {
        await this.$confirm(
          this.$t("message.confirm_submit_content"),
          this.$t("message.tips"),
          {
            confirmButtonText: this.$t("message.confirm"),
            cancelButtonText: this.$t("message.cancel"),
            type: "warning",
          }
        );
        this.submitLoading = true;

        let result = await submit({
          serviceType: this.serviceType,
          id: this.application.id,
        });
        let query = {
          ...this.$route.query,
          id: this.application.id,
          applicationNo: result.applicationNo,
        };
        if (this.isFollowing) query.isFollowing = true;
        this.$router.push({
          path: "/hzmb-h-first/success",
          query,
        });
      } catch (error) {
        if (error === false) return;
        else if (error === "cancel") return;
        else this.$error(error);
      } finally {
        this.submitLoading = false;
      }
    },
    //
    back() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.check_drivers_title {
  margin-bottom: 24px;
  font-size: 18px;
  font-weight: 500;
  color: rgba(50, 50, 50, 1);
  line-height: 25px;
}
.check_title {
  max-width: 867px;
  margin: auto;
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  color: #262626;
  border-bottom: 3px solid #38959d;
  padding: 16px 0;
}
.check_file_list {
  max-width: calc(867px - 48px);
  width: calc(100% - 48px);
  margin: 24px auto;
  border-radius: 8px;
  border: 1px solid rgba(151, 151, 151, 1);
  padding: 24px;
}
.check_file_list_content + .check_file_list_content {
  margin-top: 8px;
}
.check_file_name {
  color: #5ba7ad;
}
</style>
